import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-icon-drag",
  "use": "d2-icon-drag-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" class=\"design-iconfont\" id=\"d2-icon-drag\">\n  <path transform=\"rotate(-90 3 5)\" fill=\"#999\" d=\"M3 5H4V15H3z\" />\n  <path transform=\"rotate(-90 3 8)\" fill=\"#999\" d=\"M3 8H4V18H3z\" />\n  <path transform=\"rotate(-90 3 11)\" fill=\"#999\" d=\"M3 11H4V21H3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol